// extracted by mini-css-extract-plugin
module.exports = {"ourWork":"Programs_ourWork__1U2M6","headerImg":"Programs_headerImg__tt-Gl"};